import { defineMessages } from 'react-intl'

const scope = `procurify.platform.finance.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  manageCurrencyRatesTitle: {
    id: `${scope}.manageCurrencyRatesTitle`,
    defaultMessage: 'Manage currency rates',
  },
  manageChartOfAccountsTitle: {
    id: `${scope}.manageChartOfAccountsTitle`,
    defaultMessage: 'Manage chart of accounts',
  },
  manageTaxTypesTitle: {
    id: `${scope}.manageTaxTypesTitle`,
    defaultMessage: 'Manage tax types',
  },
})
